import styled from 'styled-components'

export const InspectPane = styled.div`
  position: fixed;
  top: calc(1em + 4px);
  right: calc(1em + 4px);
  width: 600px;
  min-height: 100px;
  background-color: #77889970;
  font-size: 18px;
  line-height: 1.5;
  padding: 0;
  z-index: 99;
  padding: 8px;
  border-radius: 6px;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);
`

export const Section = styled.section`
  padding: 1.5rem;
  font-size: 1.4rem;
  line-height: 1.5em;
  flex: 0 1 50%;
  position: relative;
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0.75rem;
    left: 0.75rem;
    width: calc(100% - 1.5rem);
    height: calc(100% - 1.5rem);
    background-color: ${(props) => props.theme.colors.developer.background};
  }
`

export const SectionContent = styled.div`
  color: ${(props) => props.theme.colors.developer.text};
  header {
    margin-bottom: 0.5rem;
    background-color: rgba(0, 0, 0, 0.1);
    padding: 0 8px;
    border-radius: 8px;
  }
  div {
    float: left;
    width: 50%;
    padding: 0 8px;
    line-break: anywhere;
    word-break: break-all;
  }
  p > span {
    opacity: 0.6;
  }
  &:after {
    content: '';
    display: block;
    clear: both;
  }
`
